import React from 'react';
import { useFooterNav } from '@hooks/useFooterNav';
import { Footer } from '../Blocks/Footer';

export function FooterContainer() {
  const items = useFooterNav();

  return <Footer blocks={items} />;
}
